module.exports = __webpack_public_path__ + "static/media/amazon.3050e253.png";